import { DashboardCustomer, useMelioIntl } from '@melio/ar-domain';
import { Table } from '@melio/penny';

import { CustomerActions } from '../../types';

type CustomerActionCellProps = {
  row: DashboardCustomer;
  meta?: CustomerActions;
};

const handleCellClick = (e: React.MouseEvent<HTMLDivElement>) => {
  e.stopPropagation();
};

export const CustomerActionCell = ({ row: customer, meta }: CustomerActionCellProps) => {
  // console.log('CustomerActionCell', customer);
  const { formatMessage } = useMelioIntl();
  const actions = [
    {
      label: formatMessage('ar.dashboard.activities.customersTable.cells.actions.createInvoice.text'),
      onClick: () => meta?.onCreateInvoice(customer.id),
    },
    {
      label: formatMessage('ar.dashboard.activities.customersTable.cells.actions.editCustomer.text'),
      onClick: () => meta?.onEditCustomer(customer.id),
    },
  ];
  return (
    <Table.Cell onClick={handleCellClick}>
      <Table.ActionsCell options={actions} data-testid={`customer-actions-cell-${customer.id}`} />;
    </Table.Cell>
  );
};
